// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-panel {
  width: 22%;
  height: 100%;
  border-right: 1px solid gray;
  background-color: #e2d2aa63;
}

.side-menu {
  border-right: 2px solid #d0d7de;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 0.75rem 0.5rem;
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-width: 220px;
  width: 220px;
  height: 100%;
  -webkit-transition: width 0.3s ease;
  transition: width 0.3s ease;
  overflow-y: auto;
}

.side-menu.collapsed {
  width: 80px;
  min-width: 80px;
  padding: 1.5rem 0.5rem;
}

.side-menu.collapsed .ant-menu-item,
.side-menu.collapsed .ant-menu-submenu-title {
  text-align: center;
  padding: 0 !important;
  height: 48px;
  line-height: 48px;
  margin: 4px 0;
}

.side-menu.collapsed .ant-menu-item .anticon,
.side-menu.collapsed .ant-menu-submenu .anticon {
  margin: 0 !important;
  font-size: 18px;
}

.side-menu .toggle-btn {
  margin-left: calc(100% - 3rem);
  margin-bottom: 1.5rem;
  border-radius: 8px;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-weight: 500;
}

.content-area {
  padding-left: 1rem;
}

.settings-container {
  /* 3.5rem == header height (.header-container) holding the Photon logo + profile */
  height: calc(100vh - 3.5rem) !important;
  overflow: hidden;
}

/* Enhanced Menu Styling */

.side-menu .ant-menu {
  background: transparent;
  border: none;
  font-size: 13px;
}

.side-menu .ant-menu-item {
  margin: 2px 0;
  height: 34px;
  line-height: 34px;
  border-radius: 8px;
  font-weight: 500;
  color: #374151;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.side-menu .ant-menu-item:hover {
  /* background: rgba(20, 184, 166, 0.12); */
  /* color: #0d9488; */
}

.side-menu .ant-menu-item-selected {
  /* background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%); */
  background: transparent;
  color: #7d48b0 !important;
  font-weight: 600;
  /* box-shadow: 0 2px 8px rgba(20, 184, 166, 0.3); */
  border-left: 4px solid #7d48b0;
  margin-left: 8px;
  border-radius: 0 8px 8px 0;
}

.side-menu .ant-menu-submenu:has(.ant-menu-item-selected) > .ant-menu-submenu-title {
  background: #c097e7 !important;
  color: #1f2937 !important;
}

.side-menu .ant-menu-item-selected:hover {
  /* background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%) !important; */
  /* color: white !important; */
}

.side-menu .ant-menu-submenu-title {
  font-weight: 600;
  color: #1f2937;
  font-size: 13px;
  height: 36px !important;
  line-height: 36px !important;
  margin: 4px 0 2px 0;
  border-radius: 8px;
  padding: 0 12px !important;
  background: #e5d4bf85;
}

.side-menu .ant-menu-submenu-title:hover {
  /* background: rgba(20, 184, 166, 0.08); */
  /* color: #0d9488; */
}

.side-menu .ant-menu-submenu > .ant-menu {
  background: transparent;
}

.side-menu .ant-menu-item .anticon {
  font-size: 16px;
}

.side-menu .ant-menu-submenu .anticon {
  font-size: 18px;
  color: #6b7280;
}

.side-menu .ant-menu-item-selected .anticon {
  color: white;
}

/* Improved visual separation */

.side-menu .ant-menu-submenu:not(:last-child) {
  margin-bottom: 6px;
  padding-bottom: 6px;
}
`, "",{"version":3,"sources":["webpack://./pages/settings/settings.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,6DAA6D;EAC7D,uBAAuB;EACvB,iDAAyC;UAAzC,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mCAA2B;EAA3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,gDAAwC;UAAxC,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kFAAkF;EAClF,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,0BAA0B;;AAC1B;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,mEAAmE;EACnE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8EAA8E;EAC9E,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;;AAC/B;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".side-panel {\r\n  width: 22%;\r\n  height: 100%;\r\n  border-right: 1px solid gray;\r\n  background-color: #e2d2aa63;\r\n}\r\n\r\n.side-menu {\r\n  border-right: 2px solid #d0d7de;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\r\n  padding: 0.75rem 0.5rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n  min-width: 220px;\r\n  width: 220px;\r\n  height: 100%;\r\n  transition: width 0.3s ease;\r\n  overflow-y: auto;\r\n}\r\n\r\n.side-menu.collapsed {\r\n  width: 80px;\r\n  min-width: 80px;\r\n  padding: 1.5rem 0.5rem;\r\n}\r\n\r\n.side-menu.collapsed .ant-menu-item,\r\n.side-menu.collapsed .ant-menu-submenu-title {\r\n  text-align: center;\r\n  padding: 0 !important;\r\n  height: 48px;\r\n  line-height: 48px;\r\n  margin: 4px 0;\r\n}\r\n\r\n.side-menu.collapsed .ant-menu-item .anticon,\r\n.side-menu.collapsed .ant-menu-submenu .anticon {\r\n  margin: 0 !important;\r\n  font-size: 18px;\r\n}\r\n\r\n.side-menu .toggle-btn {\r\n  margin-left: calc(100% - 3rem);\r\n  margin-bottom: 1.5rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  font-weight: 500;\r\n}\r\n\r\n.content-area {\r\n  padding-left: 1rem;\r\n}\r\n\r\n.settings-container {\r\n  /* 3.5rem == header height (.header-container) holding the Photon logo + profile */\r\n  height: calc(100vh - 3.5rem) !important;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Enhanced Menu Styling */\r\n.side-menu .ant-menu {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 13px;\r\n}\r\n\r\n.side-menu .ant-menu-item {\r\n  margin: 2px 0;\r\n  height: 34px;\r\n  line-height: 34px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  color: #374151;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.side-menu .ant-menu-item:hover {\r\n  /* background: rgba(20, 184, 166, 0.12); */\r\n  /* color: #0d9488; */\r\n}\r\n\r\n.side-menu .ant-menu-item-selected {\r\n  /* background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%); */\r\n  background: transparent;\r\n  color: #7d48b0 !important;\r\n  font-weight: 600;\r\n  /* box-shadow: 0 2px 8px rgba(20, 184, 166, 0.3); */\r\n  border-left: 4px solid #7d48b0;\r\n  margin-left: 8px;\r\n  border-radius: 0 8px 8px 0;\r\n}\r\n\r\n.side-menu .ant-menu-submenu:has(.ant-menu-item-selected) > .ant-menu-submenu-title {\r\n  background: #c097e7 !important;\r\n  color: #1f2937 !important;\r\n}\r\n\r\n.side-menu .ant-menu-item-selected:hover {\r\n  /* background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%) !important; */\r\n  /* color: white !important; */\r\n}\r\n\r\n.side-menu .ant-menu-submenu-title {\r\n  font-weight: 600;\r\n  color: #1f2937;\r\n  font-size: 13px;\r\n  height: 36px !important;\r\n  line-height: 36px !important;\r\n  margin: 4px 0 2px 0;\r\n  border-radius: 8px;\r\n  padding: 0 12px !important;\r\n  background: #e5d4bf85;\r\n}\r\n\r\n.side-menu .ant-menu-submenu-title:hover {\r\n  /* background: rgba(20, 184, 166, 0.08); */\r\n  /* color: #0d9488; */\r\n}\r\n\r\n.side-menu .ant-menu-submenu > .ant-menu {\r\n  background: transparent;\r\n}\r\n\r\n.side-menu .ant-menu-item .anticon {\r\n  font-size: 16px;\r\n}\r\n\r\n.side-menu .ant-menu-submenu .anticon {\r\n  font-size: 18px;\r\n  color: #6b7280;\r\n}\r\n\r\n.side-menu .ant-menu-item-selected .anticon {\r\n  color: white;\r\n}\r\n\r\n/* Improved visual separation */\r\n.side-menu .ant-menu-submenu:not(:last-child) {\r\n  margin-bottom: 6px;\r\n  padding-bottom: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
